import { TableRowProps, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { StyledGridCustomCell, StyledGridCustomRow } from './row.styles';

export function CfDataGridRowFooter(props: {
  content: ReactNode;
  tableRowSxProps?: SxProps<Theme>;
  tableRowProps?: TableRowProps;
}): JSX.Element {
  const ref = useRef<HTMLTableRowElement>(null);
  const [hasFocus, setHasFocus] = useState(false);
  const [hasHover, setHasHover] = useState(false);

  useEffect(() => {
    // fetch parent's child in the event of virualization
    const siblings =
      ref.current?.previousElementSibling || ref.current?.parentElement?.previousElementSibling?.firstElementChild;
    if (ref.current && siblings) {
      const siblingClasses = siblings?.classList;
      if (hasFocus) {
        siblingClasses.add('CfTableRow-footerFocus');
      } else {
        siblingClasses.remove('CfTableRow-footerFocus');
      }
      if (hasHover) {
        siblingClasses.add('CfTableRow-footerHover');
      } else {
        siblingClasses.remove('CfTableRow-footerHover');
      }
    }
  }, [hasFocus, hasHover]);

  return (
    <StyledGridCustomRow
      sx={props.tableRowSxProps}
      ref={ref}
      className='CfTableRow-footer'
      onFocus={() => setHasFocus(true)}
      onBlur={() => setHasFocus(false)}
      onMouseEnter={() => setHasHover(true)}
      onMouseLeave={() => setHasHover(false)}
      {...props.tableRowProps}
    >
      <StyledGridCustomCell>{props.content}</StyledGridCustomCell>
    </StyledGridCustomRow>
  );
}
